import { render, staticRenderFns } from "./ApplicationView.vue?vue&type=template&id=0b85292e&scoped=true&"
import script from "./ApplicationView.vue?vue&type=script&lang=js&"
export * from "./ApplicationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b85292e",
  null
  
)

export default component.exports